/**
 * Where the intake screen resumes after a reload (ONB-25).
 *
 * Answers are persisted only by the final submit, so a saved profile whose
 * wizard steps are all answered means the intake was submitted. If the plan
 * isn't there yet (slow LLM, tab closed during generation), resume plan
 * generation instead of dropping the user back onto the last question.
 */
export type IntakeResumeAction = 'reveal_plan' | 'reveal_skipped' | 'generate_plan' | 'wizard';

export function intakeResumeAction(
  summary: { development_plan?: unknown; skipped?: boolean; profile_type?: string | null },
  allStepsAnswered: boolean,
): IntakeResumeAction {
  if (summary.development_plan) return 'reveal_plan';
  if (summary.skipped) return 'reveal_skipped';
  if (summary.profile_type && allStepsAnswered) return 'generate_plan';
  return 'wizard';
}
